import React, { useEffect, useState } from "react";
import { Form, Spin, Input, Divider } from "antd";
import { ReactSVG } from "react-svg";

import "./WebhookConfiguration.scss";
import PrimaryButton from "../../Buttons/PrimaryButton";
import { getTranslation } from "../../../utils/helper";
import { EVENTS } from "../../../constants";

const WebhookConfigurationSettingsForm = ({ isFetching, setting, handleSubmit }) => {
  const [form] = Form.useForm();
  const [selectedEvents, setSelectedEvents] = useState([]);

  useEffect(() => {
    if (setting) {
      const selectedEventsT = setting.webhookEvents ? setting.webhookEvents.split(",") : [];
      form.setFieldsValue({
        ...setting,
        webhookEvents: selectedEventsT,
      });
      setSelectedEvents(selectedEventsT);
    }
  }, [setting]);

  const handleOnFinish = async values => {
    const params = { ...values };
    params.webhookEvents = selectedEvents.join(",");
    handleSubmit(params);
  };

  const handleOnSelectEvent = event => {
    const selectedEventsT = [...selectedEvents];
    const index = selectedEvents.indexOf(event);
    if (index > -1) {
      selectedEventsT.splice(index, 1);
    } else {
      selectedEventsT.push(event);
    }
    setSelectedEvents(selectedEventsT);
  };

  return (
    <Spin spinning={isFetching}>
      <div className="SettingsForm WebhookConfigurationSettingsForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleOnFinish}>
          <div className="FormContent">
            <div className="FormContent__label">
              {getTranslation(setting, "Settings", "Webhook Configuration")}
              <p>
                Set up your webhook endpoint to receive live events from Parcelizer or <a>learn more about Webhooks</a>.
              </p>
            </div>
            <Form.Item label={getTranslation(setting, "Settings", "End Point URL")} name="webhookEndPointUrl">
              <Input size="large" placeholder="htttp://" />
            </Form.Item>
            <Form.Item label={getTranslation(setting, "Settings", "Description")} name="webhookDescription">
              <Input size="large" placeholder="An optional description of what this webhook endpoint is used for.." />
            </Form.Item>
            <Divider />
            <div className="ListOfEvents">
              <div className="Title">{getTranslation(setting, "Settings", "List of Events")}</div>
              <div className="Events">
                {EVENTS.map(event => (
                  <div
                    key={event}
                    className={`Event ${selectedEvents.indexOf(event) > -1 ? "selected" : ""}`}
                    onClick={() => handleOnSelectEvent(event)}>
                    {event}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Divider />
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <PrimaryButton
                label={getTranslation(setting, "Common", "Update")}
                htmlType="submit"
                icon={<ReactSVG className="icon" src="/icons/submit.svg" />}
              />
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default WebhookConfigurationSettingsForm;
